import { cn, Tooltip, TooltipContent, TooltipTrigger } from 'shared-ui';

import type { BasemapDefinition } from '../utils/basemaps';

export interface MapStyleThumbnailProps {
    basemap: BasemapDefinition;
    isSelected: boolean;
    onSelect: (id: string) => void;
}

export function MapStyleThumbnail({ basemap, isSelected, onSelect }: MapStyleThumbnailProps) {
    return (
        <Tooltip>
            <TooltipTrigger
                render={
                    <button
                        type="button"
                        aria-label={`Switch map style to ${basemap.label}`}
                        aria-pressed={isSelected}
                        onClick={() => {
                            onSelect(basemap.id);
                        }}
                        className={cn(
                            'bg-muted relative h-20 w-15 shrink-0 overflow-hidden rounded-md border transition-all',
                            'focus-visible:shadow-[0_0_0_1.5px_var(--origin-blue)] focus-visible:outline-none',
                            isSelected
                                ? 'border-2 border-[var(--origin-blue)] shadow-[0_0_0_1px_var(--origin-blue)]'
                                : 'border-border hover:border-[var(--origin-blue)] hover:shadow-[0_0_0_1.5px_var(--origin-blue)]',
                        )}
                    >
                        {basemap.thumbnailUrl ? (
                            <img src={basemap.thumbnailUrl} alt="" className="h-full w-full object-cover" aria-hidden />
                        ) : (
                            <div className="bg-muted h-full w-full" />
                        )}
                    </button>
                }
            />
            <TooltipContent side="top" align="center">
                {basemap.label}
            </TooltipContent>
        </Tooltip>
    );
}
